import React from 'react'
import "./GalleryStrip.scss";
const GalleryStrip = () => {
    return (
        <div id="gallery">
            <div className="strip"></div>
            <div className="strip"></div>
        </div>
    )
}

export default GalleryStrip
